import api from './utilBackoffice';

const controller = 'PagamentoParcela';
const url = process.env.VUE_APP_ROOT_API + controller;

export default Object.assign({}, api.GetCrud(controller, null), {
  Listar: dto => {
    return api.Axios.GetParams(url + '/ListarGrid', dto);
  },

  RequestFile: dto => {
    return api.Axios.Post(url + '/RequestFile', dto);
  },

  DownloadFile: (dto, filename) => {
    return api.Axios.DownloadExcelFile(url + '/Download', dto, filename);
  }
});
